import styled from "styled-components";

export const Container = styled.div`
  position: fixed;
  z-index: 1;

  width: 100vw;
  height: 100vh;

  display: flex;
  justify-content: center;
  align-items: center;

  background-color: white;
`;